<div class="container-fluid" id="footer">
  <div class="row">
    <div class="col-2 offset-5">
      <!--<img class="img-fluid" src="../../../assets/images/coopCulture-logo.png" alt="">-->
    </div>
  </div>
</div>
